export const styles = () => `.custom-paginator {
  font-size: 0.875rem;
  line-height: 0.875rem;
 }
`;
